import CustomerType from '../const/customer_type';
import {get} from 'lodash'; 
import { isMedCartRecItemsAllowed } from './configSelectors';
import { getSalesChannelName } from './sales_channel_selectors';

export const shouldResetShoppingCart = (state, product) => {
  if (isMedCartRecItemsAllowed(state)) {
    return false;
  }

  const { cart } = state;

  if (!cart || !product) {
    return false;
  }

  if (product.customerTypes === CustomerType.ADULT) {
    return isCartWithCustomerTypeProducts(cart, CustomerType.MEDICAL);
  } else if (product.customerTypes === CustomerType.MEDICAL) {
    return isCartWithCustomerTypeProducts(cart, CustomerType.ADULT);
  }

  return false;
}

export const isSalesChannelNameItemMismatch = (state) => {
  const currentSalesChannelName = getSalesChannelName(state);
  const {cart} = state;
  const keys = Object.keys(cart);

  for (let i=0; i<keys.length; i++) {
    const item = cart[keys[i]];

    if (item.salesChannelName !== currentSalesChannelName) {
      return true;
    }
  }

  return false;
}

export const isCartWithCustomerTypeProducts = (cart, customerType) => {
  const keys = Object.keys(cart);
  for (let i=0; i<keys.length; i++) {
    let product = cart[keys[i]];

    if (product && product.customerTypes === customerType) {
      return true;
    }
  }

  return false;
}

export const isUserAbleToAddProductByCustomerType = (state, product) => {
  const userCustomerType = get(state, 'user.customerType');
  return isValidAddProductByCustomerType(userCustomerType, product);
}

export const isValidAddProductByCustomerType = (product, customerType) => {
  if (customerType === CustomerType.ADULT) {
    return product && product.customerTypes !== CustomerType.MEDICAL;
  }

  return true;
}


// WEBPACK FOOTER //
// ./src/selectors/cartSelectors.js